import Footer from "../components/Footer";
import NavBar from "../components/NavBar";
import Slider from "../Slider";

const LandingPage = () => {
    return(
        <div>
            <NavBar />
            <Slider />
            <Footer />
        </div>
    )
};

export default LandingPage;